import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Vimeo } from "@swizec/gatsby-theme-course-platform";
export const title = "Module 4";
export const description = "";
export const image = "/chapter_headers/serverless-elements.png";
export const _frontmatter = {};
const layoutProps = {
  title,
  description,
  image,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "get-paid-with-stripe-checkout"
    }}>{`Get paid with Stripe Checkout`}</h1>
    <p>{`Time to integrate Stripe and start getting paid for all your hard work.`}</p>
    <Vimeo id="399923494" mdxType="Vimeo" />
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/af9b3110f705b25e88e09a1f605aa633/573d3/stripe.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.95964125560539%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'331\\'%20viewBox=\\'0%200%20400%20331\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M322%205l-4%203c-5%201-14%207-15%209%200%202%201%204%204%207%205%204%205%205%202%2012-2%205-1%206%206%206h5v3c-1%205%201%205%2015%206h21c10%201%2018-2%2022-6l8-6c11-7%2012-11%202-17l-7-4%205-4c5-3%207-7%203-7l-33-2c-7%200-17%203-17%206%200%202%202%201%203-1%204-3%2012-4%2023-3l11%201c2-1%2013%200%2013%201l-5%205c-6%204-6%206%201%209%2010%205%209%205%208%208l-8%206-7%206c-2%204-12%207-22%206a1875%201875%200%2000-29-1h-6v-4l1-3-5-1c-8%200-8%200-6-5%203-6%203-8-2-12l-4-5c0-2%206-6%2013-8l8-3c3-2%2011-1%2011%201h3c2-3%200-4-9-4l-9%201m-25%2045l-6%204h2l3-2c2%201-7%208-20%2017-14%2010-20%2014-20%2016l6-4a415%20415%200%200136-26c1%201%201%200%202-2%203-6%202-6-3-3m0%2021c-19%2018-29%2026-23%2018v-2c-2%200-7%2010-6%2011l13-5h-3c-5%202-4%200%201-4a338%20338%200%200018-18M43%2085c-14%201-27%202-33%204l-3%201v9l-1%2020c-1%2016-2%2044%200%2044v-15l2-36%202-21%202-1a228%20228%200%200175-3l-1%2012a226%20226%200%20002%2058l1%207c1%200%201-9-1-21l-1-34%201-23h-7c-13-2-26-2-38-1m176%205c-2%202-1%202%203%200%205-2%207%201%209%2011%201%202%201%203-4%205s-13%208-12%209l5-2%208-6%205-3%202%208c3%207%207%2013%206%207l-3-7-5-12-4-10c-2-3-7-3-10%200M42%2095c-4%203-1%204%2012%203%2014%200%2019-1%2019-2s-20-2-23%200c-2%201-3%201-5-1h-3m124%201l3%202h-6a670%20670%200%200013%202l-3%201c-3%201-5%203-3%203l8-4c0-2-11-6-12-4M21%2097c-3%200-4%200-4%202l-1%207c0%205%200%205%206%202l7-4c3-1%205-6%203-7H21m75%2017c-5%203-4%204%205%205h4l40-1a413%20413%200%2000-43-5c0-2-2-1-6%201m-42%2015l-8%202c-6%200-10%203-10%206%200%202%202%201%204-1s7-2%2011%201c3%201%206%201%208-1l4-1c3%201%204-1%200-4s-5-4-9-2m-32%2044c-15%2023-18%2051-7%2066%203%206%200%205-4%200s-5-5-2%201c5%207%2010%206%2015-3%203-4%201-4-2%201-4%205-4%205-8-3-5-12-6-18-3-33%201-6%2010-25%2014-30%202-3%203-4%201-4l-4%205m51%203c-1%206%201%208%201%202%201-6%203-4%206%208%204%2015%204%2025%201%2036-4%2012-6%2022-5%2022l1-2a1761%201761%200%20005-20c4-11%203-21%200-36-3-9-3-10%200-7h2c0-1-7-8-9-8-1%200-2%202-2%205m225%2014l-4%203v4l18%202c5%200%205%200%205%202l-1%204c0%204-3%206-11%206-10%200-12-2-12-9%200-10-1-6-1%206v10l1-5c0-2%200-2%202-1h11c8%201%208%201%207%205s-14%207-20%204l-3-1c2%206%2022%205%2024-2%202-3%206-24%205-25-2-2-15-5-21-3m7%201l-4%201c-4%200-7%202-5%204h20c2-2%202-2-3-4-7-2-8-2-8-1m-32%2017c-2%201-1%201%204%201l4%202-1%201c-1-1-43%209-44%2011-2%202-1%201%2020-4%2024-6%2022-6%2021-2l-1%203s2-1%202-3l3-4c5-4-3-8-8-5m-81%206c-1%201%200%201%202%201%205%200%207%201%209%204%202%205%201%206-3%209-8%204-13%207-13%209h1l9-6%208-4%202%206%203%207c2%202%201-2-1-8-2-3-3-7-3-10l-3-6c-3-2-10-4-11-2m100%2018v4l2%202c4%202%206%201%208-3%201-2%201-2%204%200l3%202h-4l-3%201%204%201c4%200%205-1%203-4l-2-3-4-3c-3%200-3%200-2%202l-1%203h-1c0-1-4-5-6-5l-1%203M25%20246c-7%201-8%203-9%2013-2%2015-2%2024-1%2026l22%201c18%201%2022%201%2028%203%2011%203%2016%202%2019-4l2-8-2%204c-1%204-2%205-5%207s-3%202-16-1c-5-2-23-3-46-3-1%200-1-16%201-23v-4h4c7%202%2029%203%2043%203%2017%200%2018%200%2017%206v17l2-10%202-12v-7c0-4-3-5-18-6l-19-1c-12-2-19-2-24-1m-2%202c-2%201-4%202-4%204s-2%202%2032%202c19%201%2022%201%2031%204%202%200%202%200%202-3%200-4-4-5-16-5l-19-1c-14-2-21-2-26-1m208%2013c-1%202-3%203-5%201h-5c-2-2-5-1-6%201l-1%204c1%201%2016%200%2018-1l1%201c1%204%203%204%202%200%200-2%200-3%202-4%201-1%201-1-2-1-2%201-3%201-3-1l-1-2v2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/af9b3110f705b25e88e09a1f605aa633/ca0a1/stripe.webp 223w", "/static/af9b3110f705b25e88e09a1f605aa633/75680/stripe.webp 445w", "/static/af9b3110f705b25e88e09a1f605aa633/8d1ba/stripe.webp 890w", "/static/af9b3110f705b25e88e09a1f605aa633/3838e/stripe.webp 1335w", "/static/af9b3110f705b25e88e09a1f605aa633/44758/stripe.webp 1650w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/af9b3110f705b25e88e09a1f605aa633/e92b6/stripe.png 223w", "/static/af9b3110f705b25e88e09a1f605aa633/e66bf/stripe.png 445w", "/static/af9b3110f705b25e88e09a1f605aa633/4ef49/stripe.png 890w", "/static/af9b3110f705b25e88e09a1f605aa633/4e814/stripe.png 1335w", "/static/af9b3110f705b25e88e09a1f605aa633/573d3/stripe.png 1650w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/af9b3110f705b25e88e09a1f605aa633/4ef49/stripe.png",
                "alt": "Stripe integration architecture",
                "title": "Stripe integration architecture",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Stripe integration architecture`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "improve-textarea-add-deploy-button"
    }}>{`improve textarea, add Deploy button`}</h2>
    <Vimeo id="399452125" mdxType="Vimeo" />
    <h2 {...{
      "id": "initiate-payment-proces"
    }}>{`initiate payment proces`}</h2>
    <Vimeo id="399452337" mdxType="Vimeo" />
    <h2 {...{
      "id": "create-stripe-session-pt1"
    }}>{`create Stripe session pt1`}</h2>
    <Vimeo id="399926355" mdxType="Vimeo" />
    <h2 {...{
      "id": "create-stripe-session-rest-api"
    }}>{`create Stripe session rest api`}</h2>
    <Vimeo id="399452786" mdxType="Vimeo" />
    <h3 {...{
      "id": "fix-typescript-errors"
    }}>{`fix typescript errors`}</h3>
    <Vimeo id="399452954" mdxType="Vimeo" />
    <h3 {...{
      "id": "cors-headers"
    }}>{`cors headers`}</h3>
    <Vimeo id="399783660" mdxType="Vimeo" />
    <h2 {...{
      "id": "correctly-call-createstripesession-api"
    }}>{`correctly call createStripeSession api`}</h2>
    <Vimeo id="399783811" mdxType="Vimeo" />
    <h2 {...{
      "id": "make-test-purchase"
    }}>{`make test purchase`}</h2>
    <Vimeo id="399783978" mdxType="Vimeo" />
    <h2 {...{
      "id": "show-purchase-success"
    }}>{`show purchase success`}</h2>
    <Vimeo id="399924095" mdxType="Vimeo" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      